import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoadingService } from 'src/app/_services/loading.service';
import { environment } from 'src/environments/environment';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  baseUrl = environment.baseUrl;

  key_highlights_form = new FormGroup({
    id: new FormControl(null),
    // product_id: new FormControl('', [Validators.required]),
    label: new FormControl('', [Validators.required]),
    value: new FormControl('', [Validators.required]),
  });

  product_review_form = new FormGroup({
    id: new FormControl(null),
    name: new FormControl('', [Validators.required]),
    // product_id: new FormControl('', [Validators.required]),
    rating: new FormControl('', [Validators.required]),
    review_text: new FormControl('', [Validators.required]),
  });

  constructor(private http: HttpClient,
    private loading: LoadingService) { }


  get_product_id(product_id) {
    return this.http.get(this.baseUrl + '/get_product_id/' + product_id);
  }

  get_products() {
    return this.http.get(this.baseUrl + '/get_products');
  }

  insert_product(formData: any, primary_img: any, secondary_img: any, product_categories) {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('primary_img', primary_img);
    myFormData.append('secondary_img', secondary_img);
    myFormData.append('prod_type', formData.prod_type);
    myFormData.append('prod_name', formData.prod_name);
    myFormData.append('sku', formData.sku);
    myFormData.append('prod_desc', formData.prod_desc);
    myFormData.append('regular_price', formData.regular_price);
    myFormData.append('sale_price', formData.sale_price);
    myFormData.append('stock_qty', formData.stock_qty);
    myFormData.append('min_order_qty', formData.min_order_qty);
    myFormData.append('color_id', formData.color_id);
    let is_sale = formData.is_sale ? 1 : 0;
    myFormData.append('is_sale', is_sale.toString());
    myFormData.append('is_returnable', (formData.is_returnable ? 1 : 0).toString());
    myFormData.append('is_cod', (formData.is_cod ? 1 : 0).toString());
    myFormData.append('product_rating', formData.product_rating)
    myFormData.append('brand_id', formData.brand_id);
    myFormData.append('status', formData.status);
    myFormData.append('size_chart_id', formData.size_chart_id);
    myFormData.append('product_tag', formData.product_tag);
    myFormData.append('product_quality', formData.product_quality);
    myFormData.append('pack_qty', formData.pack_qty);
    myFormData.append('pack_price', formData.pack_price);

    product_categories.forEach((category, index) => {
      for (const key in category) {
        if (category[key] !== null && category[key] !== undefined) {
          myFormData.append(`product_categories[${index}][${key}]`, category[key]);
        }
      }
    });

    return this.http.post(this.baseUrl + '/create_product', myFormData, {
      headers: headers
    });

  }

  update_product(formData: any, primary_img: any, secondary_img: any, image_1: any, image_2: any, image_3: any,
    image_4: any, image_5: any, image_6: any, product_categories, product_variations: any) {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('id', formData.id);
    myFormData.append('primary_img', primary_img);
    myFormData.append('secondary_img', secondary_img);
    myFormData.append('image_1', image_1);
    myFormData.append('image_2', image_2);
    myFormData.append('image_3', image_3);
    myFormData.append('image_4', image_4);
    myFormData.append('image_5', image_5);
    myFormData.append('image_6', image_6);
    myFormData.append('prod_type', formData.prod_type);
    myFormData.append('prod_name', formData.prod_name);
    myFormData.append('sku', formData.sku);
    myFormData.append('prod_desc', formData.prod_desc);
    myFormData.append('regular_price', formData.regular_price);
    myFormData.append('sale_price', formData.sale_price);
    myFormData.append('stock_qty', formData.stock_qty);
    myFormData.append('min_order_qty', formData.min_order_qty);
    // let is_sale = formData.is_sale ? 1 : 0;
    myFormData.append('is_sale', (formData.is_sale ? 1 : 0).toString());
    myFormData.append('is_returnable', (formData.is_returnable ? 1 : 0).toString());
    myFormData.append('is_cod', (formData.is_cod ? 1 : 0).toString());
    myFormData.append('product_rating', formData.product_rating)
    myFormData.append('color_id', formData.color_id);
    myFormData.append('brand_id', formData.brand_id);
    myFormData.append('status', formData.status);
    myFormData.append('size_chart_id', formData.size_chart_id);
    myFormData.append('product_tag', formData.product_tag);
    myFormData.append('product_quality', formData.product_quality);
    // myFormData.append('product_categories', product_categories);
    myFormData.append('pack_qty', formData.pack_qty);
    myFormData.append('pack_price', formData.pack_price);
    
    product_categories.forEach((category, index) => {
      for (const key in category) {
        if (category[key] !== null && category[key] !== undefined) {
          myFormData.append(`product_categories[${index}][${key}]`, category[key]);
        }
      }
    });
    // myFormData.append('product_variations', product_variations);
    product_variations.forEach((variation, index) => {
      for (const key in variation) {
        if (variation[key] !== undefined) {
          myFormData.append(`product_variations[${index}][${key}]`, variation[key]);
        }
      }
    });


    //console.log(myFormData);
    return this.http.post(this.baseUrl + '/update_product/' + formData.id, myFormData, {
      headers: headers
    });
  }

  get_active_category() {
    return this.http.get(this.baseUrl + '/get_active_category');
  }

  get_categories_hierarchy() {
    return this.http.get(this.baseUrl + '/get_categories_hierarchy');
  }

  get_active_brand() {
    return this.http.get(this.baseUrl + '/get_active_brand');
  }

  get_active_colors() {
    return this.http.get(this.baseUrl + '/get_active_colors');
  }

  get_active_sizes() {
    return this.http.get(this.baseUrl + '/get_active_sizes');
  }

  get_size_charts() {
    return this.http.get(this.baseUrl + '/get_size_charts');
  }

  delete_product_variation(id: any) {
    return this.http.get(this.baseUrl + '/delete_product_variation/' + id);
  }

  add_product_variation_size(size_variation: any) {
    return this.http.post(this.baseUrl + '/add_product_variation_size', size_variation);
  }

  add_product_variation_color(color_variation: any) {
    return this.http.post(this.baseUrl + '/add_product_variation_color', color_variation);
  }

  insert_product_size(formData: any) {
    return this.http.post(this.baseUrl + '/create_size', {
      size_name: formData.size_name,
      size_code: formData.size_code,
    });
  }


  insert_product_color(formData: any) {
    return this.http.post(this.baseUrl + '/create_color', {
      color_name: formData.color_name,
      color_code: formData.color_code,
      status: 1,
    });
  }

  delete_product_image(product_id: any, imgno: any) {
    return this.http.post(this.baseUrl + '/delete_product_image/' + product_id, { imgno: imgno });
  }

  
  

/* Product Review */
  get_product_review(product_id: any) {
    return this.http.get(this.baseUrl + '/get_product_review/' + product_id);
  }

  insert_product_review(formData: any, product_id) {
    return this.http.post(this.baseUrl + '/create_review/' + product_id, {
      rating: formData.rating,
      name: formData.name,
      review_text: formData.review_text,
    });
  }

  populateProductReviewForm(rowData: any) {
    console.log(rowData);
    rowData.rating = String(rowData.rating);
    this.product_review_form.setValue(_.omit(rowData, 'product_id', 'user_id','is_approved','approved_by', 'created_at', 'deleted_at', 'updated_at'));
  }

  update_product_review(formData: any) {
    return this.http.put(this.baseUrl + '/update_review/' + formData.id, {
      // id: formData.id,
      name: formData.name,
      rating: formData.rating,
      review_text: formData.review_text,
    });
  }

  update_review_status(reviewId: any, status: any) {
    return this.http.put(this.baseUrl + '/update_review_status/' + reviewId + '/' + status, {});
  }

  delete_product_review(id: any) {
    return this.http.delete(this.baseUrl + '/delete_review/' + id);
  }


/* Product Key Highlight */

  get_product_key_highlight(product_id: any) {
    return this.http.get(this.baseUrl + '/get_product_key_highlight/' + product_id);
  }

  insert_key_highlights(formData: any, product_id) {
    return this.http.post(this.baseUrl + '/add_product_key_highlight/' + product_id, {
      label: formData.label,
      value: formData.value,
    });
  }

  populateKeyHighlightsForm(rowData: any) {
    console.log(rowData);
    //rowData.rating = String(rowData.rating);
    this.key_highlights_form.setValue(_.omit(rowData, 'product_id', 'created_at', 'deleted_at', 'updated_at'));
  }

  update_key_highlights(formData: any) {
    return this.http.put(this.baseUrl + '/update_key_highlights/' + formData.id, {
      // id: formData.id,
      label: formData.label,
      value: formData.value,
    });
  }

  delete_key_highlight(id: any) {
    return this.http.delete(this.baseUrl + '/delete_product_key_highlight/' + id);
  }



}
